import { Component, OnDestroy } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'mpro-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss', './../login-common.scss']
})
export class ForgotPasswordComponent implements OnDestroy {
  public email: UntypedFormControl = new UntypedFormControl('', [Validators.required, Validators.email]);
  public success: boolean = false;
  public error: string;

  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(private authService: AuthService, private router: Router) {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/'])
    }
  }

  public resetPassword(): void {
    this.error = '';

    if (!this.email.valid) {
      return;
    }

    this.authService.resetPasswordRequest(this.email.value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => this.success = true,
        err => this.error = err.error.errorDescription
      );
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
